import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { Checkbox } from "../ui/checkbox";
import { Label } from "../ui/label";
import { Button } from "../ui/button";
import { FileText, Save, Loader2, Mail } from "lucide-react";

const CrmActivityReportCard = React.memo(function CrmActivityReportCard({
  enabled,
  setEnabled,
  recipients,
  saving,
  onSave,
}) {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <FileText className="h-5 w-5 text-indigo-600" />
          <CardTitle>CRM Activity Report</CardTitle>
        </div>
        <CardDescription>
          Daily PDF report sent at 7 PM ET (Mon–Fri) summarising calls, emails, and SMS
          logged by Megha Sethi, Gregory, and Salina.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">

        {/* Enable toggle */}
        <div className="flex items-center space-x-3 p-4 bg-indigo-50 rounded-lg border border-indigo-200">
          <Checkbox
            id="enable-crm-activity-report"
            checked={enabled}
            onCheckedChange={setEnabled}
          />
          <Label htmlFor="enable-crm-activity-report" className="text-sm font-medium cursor-pointer">
            Enable CRM Activity Report
          </Label>
        </div>

        {/* Recipients info — always visible */}
        <div className="bg-slate-50 border border-slate-200 rounded-lg p-4 space-y-2">
          <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide flex items-center gap-1">
            <Mail className="h-3.5 w-3.5" />
            Report sent to
          </p>
          {(recipients || []).map((email) => (
            <p key={email} className="text-sm text-slate-700 font-medium pl-1">
              {email}
            </p>
          ))}
        </div>

        {/* Save */}
        <div className="pt-2 flex justify-end">
          <Button onClick={onSave} disabled={saving}>
            {saving ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Saving...
              </>
            ) : (
              <>
                <Save className="mr-2 h-4 w-4" />
                Save Settings
              </>
            )}
          </Button>
        </div>

      </CardContent>
    </Card>
  );
});

export default CrmActivityReportCard;
